// eslint-disable-next-line no-use-before-define
import React, { useState } from 'react';
import { useSendbirdStateContext } from '@sendbird/uikit-react';
import ChannelListUI from '@sendbird/uikit-react/ChannelList/components/ChannelListUI';
import { useChannelListContext, ChannelListProvider } from '@sendbird/uikit-react/ChannelList/context';
import { addChannelListAccessibility } from '../../js/addAccessibility';
import ChannelListHeader from './ChannelListHeader';
import ChannelListSkeleton from './ChannelListSkeleton.jsx';
import EmptyChannelListParentView from './EmptyChannelListParentView';
import EmptyChannelListSitterView from './EmptyChannelListSitterView';
import ChannelPreview from './ChannelPreview.jsx';
import useMediaQuery from '../../js/useMediaQuery.js';

const errorState = () => {
  return <div />;
};

const CustomChannelListUI = ({ hasError, renderChannelPreview, updateAllChannels, accountType }) => {
  const renderEmptyPlaceholder = () => {
    if (accountType === 'sitter') {
      return <EmptyChannelListSitterView />;
    }
    if (accountType === 'parent') {
      return <EmptyChannelListParentView />;
    }
    return null;
  };

  const { allChannels } = useChannelListContext();
  updateAllChannels(allChannels);

  return (
    <ChannelListUI
      renderHeader={ChannelListHeader}
      renderPlaceHolderEmptyList={renderEmptyPlaceholder}
      renderPlaceHolderLoading={hasError ? errorState : ChannelListSkeleton}
      renderChannelPreview={renderChannelPreview}
    />
  );
};

const ChannelListWrapper = ({
  onChannelSelect,
  userId,
  accountType,
  updateErrorState,
  hasError,
  disableAutoSelect,
  currentChannelUrl,
  updateAllChannels,
}) => {
  const renderChannelPreview = (props) => {
    return <ChannelPreview props={props} userId={userId} currentChannelUrl={currentChannelUrl} accountType={accountType} />;
  };

  const context = useSendbirdStateContext();

  const mobile = useMediaQuery('(max-width: 767px)');

  if (context.stores.sdkStore.error) {
    updateErrorState(true);
  }

  const [queries] = useState({
    channelListQuery: {
      limit: 100,
    },
  });

  addChannelListAccessibility();
  return (
    <div className={`sendbird-app__channellist-wrap ${mobile && accountType !== 'sitter' && 'mb-80'}`}>
      <ChannelListProvider onChannelSelect={onChannelSelect} disableAutoSelect={disableAutoSelect} queries={queries}>
        <CustomChannelListUI
          renderHeader={ChannelListHeader}
          accountType={accountType}
          renderPlaceHolderLoading={hasError ? errorState : ChannelListSkeleton}
          renderChannelPreview={renderChannelPreview}
          updateAllChannels={updateAllChannels}
        />
      </ChannelListProvider>
    </div>
  );
};

export default ChannelListWrapper;
